import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight, CheckCircle2, Mail, MapPin, Phone, ShieldCheck } from 'lucide-react';
export function RecruitmentSafetyPage() {
  return <div className="bg-white pt-20" data-id="element-792" data-mp="mbz8s513weq">
      <section className="bg-navy-900 py-20 text-white" data-id="element-793" data-mp="ndllsrhw5br">
        <div className="max-w-5xl mx-auto px-6 lg:px-12" data-id="element-794" data-mp="5jc3cxibip37">
          <div className="flex items-center gap-3 mb-6" data-id="element-795" data-mp="341zj1ce8gv6u">
            <ShieldCheck className="h-6 w-6 text-gold-500" data-id="element-796" data-mp="343kdl20jse4p" />
            <span className="text-gold-500 font-semibold tracking-[0.24em] uppercase text-xs" data-id="element-797" data-mp="390kih9lnvau8">
              Candidate Safety
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-serif font-bold leading-tight max-w-4xl" data-id="element-798" data-mp="3e29yl3nqqep6">
            Protect yourself from recruitment fraud.
          </h1>
          <p className="mt-6 max-w-3xl text-lg text-gray-300 leading-relaxed" data-id="element-799" data-mp="t8wqlsli88ia">
            TalentBridge Global is committed to a safe, transparent search experience. Use this page to verify our official channels and report suspicious outreach.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gold-500/10 border-y border-gold-500/20" data-id="element-800" data-mp="3jtwiswp3oa4d">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 flex gap-4 items-start" data-id="element-801" data-mp="3euta929wvlrn">
          <AlertTriangle className="h-6 w-6 text-gold-600 flex-shrink-0 mt-0.5" data-id="element-802" data-mp="3ewxpggd9g778" />
          <div data-id="element-803" data-mp="3at7yxld0zfjk">
            <h2 className="text-xl font-serif font-bold text-navy-900 mb-2" data-id="element-804" data-mp="3avu6hkzx1v1s">
              Important: TalentBridge will never ask candidates to pay.
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-805" data-mp="3123pf164cmw4">
              We do not request gift cards, cryptocurrency, banking credentials, or payment for job access, interviews, background checks, or placement. Treat any such request as suspicious.
            </p>
          </div>
        </div>
      </section>

      <main className="max-w-5xl mx-auto px-6 lg:px-12 py-20 space-y-16" data-id="element-806" data-mp="2n33xnknb7rvq">
        <section data-id="element-807" data-mp="2i656nayy011r">
          <div className="flex items-center gap-3 mb-6" data-id="element-808" data-mp="2i5m00qeqsz31">
            <div className="w-10 h-px bg-gold-500" data-id="element-809" data-mp="28goqhd1krxy7" />
            <span className="text-gold-600 font-semibold tracking-[0.22em] uppercase text-xs" data-id="element-810" data-mp="28jazlh446lij">
              Verify Our Channels
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-200" data-id="element-811" data-mp="1yk294y8gjp0x">
            <div className="bg-white p-7" data-id="element-812" data-mp="23hlpq4smodw1">
              <Mail className="h-6 w-6 text-gold-500 mb-5" data-id="element-813" data-mp="23idkjdeei7l9" />
              <h2 className="font-serif font-bold text-xl text-navy-900 mb-2" data-id="element-814" data-mp="2r7fzgdhnhmc2">Official email</h2>
              <a href="mailto:contact@talentbridge.blog" className="text-gray-700 hover:text-gold-600 transition-colors break-all" data-id="element-815" data-mp="2w72b4ihtyuir">
                contact@talentbridge.blog
              </a>
            </div>
            <div className="bg-white p-7" data-id="element-816" data-mp="2mfxxbm3w5fpi">
              <Phone className="h-6 w-6 text-gold-500 mb-5" data-id="element-817" data-mp="2mewo7n6fr3af" />
              <h2 className="font-serif font-bold text-xl text-navy-900 mb-2" data-id="element-818" data-mp="3a5s87y4ngu74">Official phone</h2>
              <a href="tel:+16788073391" className="text-gray-700 hover:text-gold-600 transition-colors" data-id="element-819" data-mp="3eyburklbezo2">
                +1 (678) 807-3391
              </a>
            </div>
            <div className="bg-white p-7" data-id="element-820" data-mp="yjqg7z5osui5">
              <MapPin className="h-6 w-6 text-gold-500 mb-5" data-id="element-821" data-mp="yiyhifgsmgnn" />
              <h2 className="font-serif font-bold text-xl text-navy-900 mb-2" data-id="element-822" data-mp="1cav7odywighe">Headquarters</h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-823" data-mp="188rspfd0wtrd">
                357 7th Ave, 2nd Floor<br data-id="element-824" data-mp="kj5t4qsqociu" />
                New York, NY 10001
              </p>
            </div>
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-825" data-mp="fl48w2jku75s">
          <div data-id="element-826" data-mp="tjvndq2cpuug">
            <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6" data-id="element-827" data-mp="tknasdlsom9n">What legitimate outreach looks like</h2>
            <ul className="space-y-4" data-id="element-828" data-mp="ojzg9hycxnao">
              {['A recruiter identifies themselves and explains the role or purpose of the conversation.', 'You can independently confirm the contact details through this website.', 'We discuss sensitive information only through appropriate, professional channels.', 'We never pressure you to act immediately or conceal communication from your employer.'].map(item => <li key={item} className="flex items-start gap-3 text-gray-700 leading-relaxed" data-id="element-829" data-mp="357iljjtpgi3g">
                  <CheckCircle2 className="h-5 w-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-830" data-mp="3a8og7n6xeffm" />
                  <span data-id="element-831" data-mp="3ea09c2p0disk">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-gray-50 border border-gray-200 p-8" data-id="element-832" data-mp="3j7jm0y625nie">
            <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6" data-id="element-833" data-mp="3nz1mll465m2u">Report suspicious outreach</h2>
            <p className="text-gray-700 leading-relaxed mb-6" data-id="element-834" data-mp="3sxv4dpqhnz8t">
              Forward the message, sender details, and any relevant screenshots to our team. We will review reports and help confirm whether the outreach came from TalentBridge.
            </p>
            <a href="mailto:contact@talentbridge.blog?subject=Suspicious%20recruitment%20outreach%20report" className="inline-flex items-center gap-2 text-navy-900 font-semibold hover:text-gold-600 transition-colors" data-id="element-835" data-mp="5too02ty8krz">
              Report suspicious outreach <ArrowRight className="h-4 w-4" data-id="element-836" data-mp="1hbkm8x6e6xqp" />
            </a>
          </div>
        </section>

        <section className="border-t border-gray-200 pt-12" data-id="element-837" data-mp="1cczrhd9wt69n">
          <h2 className="text-3xl font-serif font-bold text-navy-900 mb-4" data-id="element-838" data-mp="29z6uwjuh8skf">Questions about a search?</h2>
          <p className="text-gray-700 leading-relaxed max-w-3xl mb-6" data-id="element-839" data-mp="24zu1fg93on8v">
            Speak with us directly before sharing personal information. We are happy to confirm whether a recruiter, mandate, or message is legitimate.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-2 text-gold-600 font-semibold hover:text-navy-900 transition-colors" data-id="element-840" data-mp="1va10d96l3qiv">
            Contact TalentBridge <ArrowRight className="h-4 w-4" data-id="element-841" data-mp="2nyps4hlr2jhy" />
          </Link>
        </section>
      </main>
    </div>;
}